import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Task } from '../../../../../workflow/types';

@Component({
    selector: 'mcb-task-details',
    templateUrl: './task-details.component.html',
})
export class TaskDetailsComponent {
    @Input() task: Task;
}
